import React, { useMemo } from 'react';
import PlayerUi, { PlayerUiHandlersPropsType } from '@/components/Player';
import {
  getCurrentFrame,
  hasVocamData,
  useIsMobileScreenSize,
} from '@/lib/util';
import { ElearningDataType } from '@/modules/types/elearning';
import { FrameDataType } from '@/modules/types/frame';
import { QuizDataType } from '@/modules/types/quiz';
import { ResourceType } from '@/modules/types/resource';
import { useGetVideoLinkQuery } from '@/modules/services/videoLibrary';
import { ElearningBehaviourSettingsDataInterface } from '@/modules/types/tenant';

type TDraftViewProps = {
  isQuizReady: boolean;
  elearning?: ElearningDataType;
  frames: FrameDataType[];
  currentFrameId: string;
  playerHelper: any;
  resources: ResourceType[];
  handlers: PlayerUiHandlersPropsType;
  quiz: QuizDataType;
  elearningBehaviourSettings: ElearningBehaviourSettingsDataInterface;
};

const DraftView = ({
  isQuizReady,
  elearning,
  frames,
  currentFrameId,
  playerHelper,
  resources,
  handlers,
  quiz,
  elearningBehaviourSettings,
}: TDraftViewProps): React.ReactElement => {
  const { isMobile } = useIsMobileScreenSize();

  const currentFrame = useMemo(
    () => getCurrentFrame(frames, currentFrameId),
    [frames, currentFrameId],
  );
  const { data: vocamVideoLink } = useGetVideoLinkQuery(currentFrameId, {
    skip: !currentFrameId || !hasVocamData(currentFrame),
  });

  return (
    <PlayerUi
      isPlayable={true}
      currentFrameId={currentFrameId}
      isQuizEnabled={isQuizReady}
      elearning={elearning}
      frames={frames}
      quiz={quiz}
      resources={resources}
      helperContent={playerHelper.content || []}
      helperFaq={playerHelper.faq || []}
      handlers={handlers}
      isMobileView={isMobile}
      vocamVideoLink={vocamVideoLink}
      elearningBehaviourSettings={elearningBehaviourSettings}
    />
  );
};

export default DraftView;
